import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelDynamic as _vModelDynamic, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "flex flex-col" }
const _hoisted_2 = { class: "flex items-center mb-1" }
const _hoisted_3 = { class: "mb-1 flex-grow" }
const _hoisted_4 = ["src"]
const _hoisted_5 = ["type"]

import Icons from "@/components/Icons";
import { ref, watchEffect } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'Input',
  props: {
  labelValue: {
    type: String,
    required: true,
  },
  typeValue: {
    type: String,
    required: false,
  },
  modelValue: {
    type: [Number, String],
    required: false,
  },
  hasIcon: {
    type: Boolean,
    required: false,
  },
  imageSrc: {
    type: String,
    required: false,
  },
  maxValue: {
    type: Number,
    required: false,
  },
},
  emits: ["update:modelValue"],
  setup(__props, { emit: __emit }) {

const props = __props;

const showImage = ref(false);

const displayModelValue = ref(props.modelValue);

const emit = __emit;

watchEffect(() => {
  if (
    props.maxValue !== undefined &&
    displayModelValue.value > props.maxValue
  ) {
    displayModelValue.value = props.maxValue;
    emit("update:modelValue", props.maxValue);
  } else {
    emit("update:modelValue", displayModelValue.value);
  }
});

const handleInput = (event) => {
  const inputValue = event.target.value;

  if (props.typeValue === "number") {
    let value = parseFloat(inputValue);
    if (isNaN(value)) {
      value = 0;
    }
    if (props.maxValue !== undefined && value > props.maxValue) {
      value = props.maxValue;
    }
    emit("update:modelValue", value);
  } else {
    emit("update:modelValue", inputValue);
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("label", _hoisted_3, _toDisplayString(props.labelValue), 1),
      (props.hasIcon)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            onMouseover: _cache[0] || (_cache[0] = ($event: any) => (showImage.value = true)),
            onMouseout: _cache[1] || (_cache[1] = ($event: any) => (showImage.value = false)),
            class: "flex-none relative"
          }, [
            _createVNode(_unref(Icons), { name: "info-logo" }),
            (showImage.value)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  src: __props.imageSrc,
                  class: "absolute z-50",
                  style: {"width":"800px","height":"auto","min-width":"800px","min-height":"400px"}
                }, null, 8, _hoisted_4))
              : _createCommentVNode("", true)
          ], 32))
        : _createCommentVNode("", true)
    ]),
    _withDirectives(_createElementVNode("input", {
      type: props.typeValue,
      class: "border-2 required rounded text-black",
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((displayModelValue).value = $event)),
      onInput: _cache[3] || (_cache[3] = ($event: any) => (handleInput($event)))
    }, null, 40, _hoisted_5), [
      [
        _vModelDynamic,
        displayModelValue.value,
        void 0,
        { number: true }
      ]
    ])
  ]))
}
}

})